module.exports = __webpack_public_path__ + "img/头像空白图.b0cc7b78.png";